import React from "react";
import {
  Modal,
  ModalFooter,
  ModalButton,
  ModalBody,
  modalConnect,
} from "@modal";
import {
  ceModalRemoveAttachmentConfirm,
  ceModalRemoveAttachmentCancel,
} from "@js/actions/studio/campaign_content_section/modal_remove_attachment.js";

const ModalRemoveAttachment = modalConnect((props) => {
  return (
    <Modal
      title={t("phrases.confirm_deletion")}
      onCancel={() => {
        props.dispatch(ceModalRemoveAttachmentCancel());
      }}
    >
      <ModalBody>
        <p>
          {t("phrases.react_content.remove_attachment_confirm.please_confirm")}
          &nbsp;
          <strong>{props.attachment_name}</strong>. &nbsp;
          {t("phrases.react_content.remove_attachment_confirm.cannot_undo")}
        </p>
      </ModalBody>
      <ModalFooter>
        <ModalButton
          onClick={() => {
            props.dispatch(ceModalRemoveAttachmentCancel());
          }}
          text={t("buttons.cancel")}
          diminished
        />
        <ModalButton
          onClick={() => {
            props.dispatch(ceModalRemoveAttachmentConfirm());
          }}
          text={t("phrases.react_content.remove_attachment")}
          dangerous
        />
      </ModalFooter>
    </Modal>
  );
});

export default ModalRemoveAttachment;
